import { useState } from 'react';

import api from '../service/api';
import { ButtonArrow } from './gallery';

export const fileSrc = (file) => (/^((https?:)?\/|data:)/.test(file) ? file : api.pathRepoFile(file));

const WelcomeCarousel = ({ files = [] }) => {
  const [index, setIndex] = useState(0);
  const count = files.length;

  if (count === 0) return '';

  const onChangeImage = (event, current) => {
    event.preventDefault();
    event.stopPropagation();
    setIndex((current + count) % count);
  };

  return (
    <div className="flex flex-col items-center w-full">
      {count > 1 && (
        <ButtonArrow
          type="button"
          className="absolute hidden xs:flex items-center justify-center w-16 h-16 top-1/2 -mt-8 rounded-full bg-gray-600 -left-20"
          onClick={(event) => onChangeImage(event, index - 1)}
        >
          {/* ICON arrow left*/}
          <svg className="w-6 h-6" viewBox="0 0 1024 1024" fill="currentColor">
            <path d="M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z" />
          </svg>
        </ButtonArrow>
      )}
      <div className="grid place-items-center">
        {files.map((file, i) => (
          <img
            key={file}
            src={fileSrc(file)}
            className={`col-start-1 row-start-1 object-contain max-w-full max-h-[80vh] transition-opacity duration-300
              ${i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            alt=""
          />
        ))}
      </div>
      {count > 1 && (
        <div className="flex justify-center w-full mx-auto mt-2">
          {files.map((file, i) => (
            <button
              type="button"
              key={file}
              onClick={(event) => onChangeImage(event, i)}
              className="p-2.5"
            >
              <span className={`w-4 h-4 block rounded-full ${i === index ? 'bg-primary' : 'bg-primary opacity-30'}`} />
            </button>
          ))}
        </div>
      )}
      {count > 1 && (
        <ButtonArrow
          type="button"
          className="absolute hidden xs:flex items-center justify-center w-16 h-16 -mt-8 rounded-full bg-gray-600 top-1/2 -right-20"
          onClick={(event) => onChangeImage(event, index + 1)}
        >
          {/* ICON arrow right */}
          <svg className="w-6 h-6" viewBox="0 0 1024 1024" fill="currentColor">
            <path d="M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z" />
          </svg>
        </ButtonArrow>
      )}
    </div>
  );
};

export default WelcomeCarousel;
